import { render, staticRenderFns } from "./HomeBottomSection.vue?vue&type=template&id=973df79e&scoped=true"
import script from "./HomeBottomSection.vue?vue&type=script&lang=js"
export * from "./HomeBottomSection.vue?vue&type=script&lang=js"
import style0 from "./HomeBottomSection.vue?vue&type=style&index=0&id=973df79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973df79e",
  null
  
)

export default component.exports